import styled from "styled-components";
import Form from "../../components/authorization/login/Form";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

function Login(){
    return(
        <Container>
            <Header />
            <Form/>
            <Footer />
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    min-width: 100vw;
`

export default Login;